import { render, staticRenderFns } from "./SalePreview.vue?vue&type=template&id=5c83ec32&scoped=true&"
import script from "./SalePreview.vue?vue&type=script&lang=js&"
export * from "./SalePreview.vue?vue&type=script&lang=js&"
import style0 from "./SalePreview.vue?vue&type=style&index=0&id=5c83ec32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83ec32",
  null
  
)

export default component.exports